import { Header } from "../common/header";
import { SignupTechForm } from "../signup-forms/signup-tech";
import { Footer } from "./main-page/footer";

export const DentalTechSignup = () => {
    return (
        <>
            <Header title="Dental Talent Sign Up" />
            <div className="container-fluid gray-container">
                <div className="container px-0 px-md-5">
                    <div className="row p-0 px-md-4 py-md-5">
                        <SignupTechForm />
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};
